export const colorChoices = [
    { id: '#F2F2F2', name: 'common.colors.gray', shades: { 50: '#F7F7F7', 200: '#E8E8E8' } },
    { id: '#FFEBAF', name: 'common.colors.yellow', shades: { 50: '#FFF8DF', 200: '#FFDF7B' } },
    { id: '#BFEECD', name: 'common.colors.green', shades: { 50: '#E5F9EB', 200: '#94E4AE' } },
    { id: '#BCD9FF', name: 'common.colors.blue', shades: { 50: '#E3F0FF', 200: '#91C3FF' } },
    { id: '#FFD2D8', name: 'common.colors.red', shades: { 50: '#FFEDF0', 200: '#F8A2A3' } },
    { id: '#DDC2FB', name: 'common.colors.purple', shades: { 50: '#F3E6FE', 200: '#C697FA' } },
];
